import styles from '../styles/components/form/input-label.module.scss';

export default function InputLabel({ children }) {
  return <div className={styles.label}>{children}</div>;
}
